const returnPeriodValues = [20, 50, 100, 200, 500, 1000, 1500] as const;

export type ReturnPeriod = (typeof returnPeriodValues)[number];

export const returnPeriods = returnPeriodValues as any as ReturnPeriod[];
